import { render, staticRenderFns } from "./Riplay.vue?vue&type=template&id=207859c4&scoped=true"
var script = {}
import style0 from "./Riplay.vue?vue&type=style&index=0&id=207859c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207859c4",
  null
  
)

export default component.exports